// B Shocked Electrical — Shopify Theme JS

// Cart AJAX add with toast notification
document.addEventListener('submit', async function(e) {
  const form = e.target;
  if (!form.action || !form.action.includes('/cart/add')) return;
  e.preventDefault();
  const btn = form.querySelector('[type=submit]');
  const orig = btn ? btn.textContent : '';
  if (btn) { btn.textContent = '✓ Added'; btn.style.background = '#22c55e'; }
  try {
    await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
    updateCartCount();
    showToast('Added to cart!', '🛒');
    setTimeout(() => {
      if (btn) { btn.textContent = orig; btn.style.background = ''; }
    }, 1800);
  } catch(err) {
    if (btn) { btn.textContent = orig; btn.style.background = ''; }
    form.submit();
  }
});

async function updateCartCount() {
  try {
    const r = await fetch('/cart.js');
    const c = await r.json();
    document.querySelectorAll('.cart-count').forEach(el => el.textContent = c.item_count);
  } catch(e) {}
}

function showToast(msg, icon='⚡') {
  const t = document.createElement('div');
  t.style.cssText = 'position:fixed;bottom:1.5rem;right:1.5rem;background:#1E2230;border:1px solid rgba(245,196,0,0.3);color:#F2F0EB;padding:0.85rem 1.25rem;border-radius:12px;font-family:Outfit,sans-serif;font-size:0.85rem;font-weight:600;z-index:9999;display:flex;align-items:center;gap:0.5rem;box-shadow:0 8px 32px rgba(0,0,0,0.5);animation:slideUp 0.3s ease';
  t.innerHTML = `<span>${icon}</span><span>${msg}</span>`;
  document.body.appendChild(t);
  setTimeout(() => t.remove(), 3000);
}

const style = document.createElement('style');
style.textContent = '@keyframes slideUp{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}';
document.head.appendChild(style);

updateCartCount();

/* ═══════════════════════════════════════════════════
   BSE COLLECTION FILTER ENGINE — v2.4.0
   ═══════════════════════════════════════════════════ */

(function() {
  'use strict';

  // ── STATE ──────────────────────────────────────────
  const state = {
    keyword:  '',
    category: 'all',
    brand:    '',
    inStock:  false,
    priceMin: 0,
    priceMax: 50000
  };

  // ── CATEGORY KEYWORD MAP ───────────────────────────
  // Maps tile data-cat → keywords matched against product data-type and data-tags
  const catMap = {
    all:       null,
    cable:     ['cable', 'wire', 'flex', 'csa', 'twin', 'earth', 'armoured'],
    mcb:       ['mcb', 'switch', 'breaker', 'isolator', 'rccb', 'rcbo', 'circuit'],
    board:     ['board', 'distribut', 'db', 'enclosure', 'panel'],
    light:     ['light', 'led', 'lamp', 'bulb', 'fitting', 'downlight', 'tube', 'strip'],
    solar:     ['solar', 'inverter', 'battery', 'pv', 'charge', 'lithium', 'ups'],
    conduit:   ['conduit', 'trunking', 'duct', 'pipe', 'saddle', 'clip'],
    plug:      ['plug', 'socket', 'outlet', 'adaptor', 'extension', 'multi'],
    protect:   ['surge', 'protection', 'spd', 'arrester', 'lightning', 'earth'],
    tool:      ['tool', 'plier', 'tester', 'meter', 'drill', 'crimper', 'stripper'],
    accessory: ['accessory', 'connector', 'terminal', 'lug', 'ferrule', 'gland', 'tape']
  };

  // ── DOM REFS ───────────────────────────────────────
  let cards, grid, noResults, resultCount, statusBar, activeTags, showingCount;
  let filterBar, spacer;

  function init() {
    grid        = document.getElementById('bse-product-grid');
    noResults   = document.getElementById('bse-no-results');
    resultCount = document.getElementById('bse-result-count');
    statusBar   = document.getElementById('bse-filter-status');
    activeTags  = document.getElementById('bse-active-tags');
    showingCount= document.getElementById('bse-showing-count');
    filterBar   = document.getElementById('bse-filter-bar');
    spacer      = document.getElementById('bse-filter-spacer');

    if (!grid) return; // not a collection page

    cards = Array.from(grid.querySelectorAll('.product-card'));

    // Detect price range from products
    let maxPrice = 0;
    cards.forEach(c => {
      const p = parseInt(c.dataset.price || 0);
      if (p > maxPrice) maxPrice = p;
    });
    // Convert from Shopify cents to Rands, round up nicely
    const maxRand = Math.ceil((maxPrice / 100) / 1000) * 1000 || 50000;
    state.priceMax = maxRand;

    // Update sliders
    const sliderMin = document.getElementById('bse-price-min');
    const sliderMax = document.getElementById('bse-price-max');
    if (sliderMin && sliderMax) {
      sliderMin.max = maxRand;
      sliderMax.max = maxRand;
      sliderMax.value = maxRand;
      document.getElementById('bse-price-max-val').textContent = maxRand.toLocaleString('en-ZA');
    }
    updateRangeFill();

    // Bind events
    bindEvents();

    // Set spacer height to match filter bar height
    adjustSpacer();
    window.addEventListener('resize', adjustSpacer);

    applyFilters();
  }

  function adjustSpacer() {
    if (filterBar && spacer) {
      spacer.style.height = '0px'; // filter bar is sticky, no spacer needed
    }
  }

  // ── EVENT BINDINGS ──────────────────────────────────
  function bindEvents() {
    // Keyword search
    const kwInput = document.getElementById('bse-keyword');
    const kwClear = document.getElementById('bse-search-clear');
    if (kwInput) {
      kwInput.addEventListener('input', function() {
        state.keyword = this.value.trim().toLowerCase();
        kwClear.classList.toggle('visible', state.keyword.length > 0);
        applyFilters();
      });
    }
    if (kwClear) {
      kwClear.addEventListener('click', function() {
        kwInput.value = '';
        state.keyword = '';
        kwClear.classList.remove('visible');
        applyFilters();
      });
    }

    // In Stock toggle
    const inStock = document.getElementById('bse-instock');
    if (inStock) {
      inStock.addEventListener('change', function() {
        state.inStock = this.checked;
        applyFilters();
      });
    }

    // Brand dropdown
    const brand = document.getElementById('bse-brand');
    if (brand) {
      brand.addEventListener('change', function() {
        state.brand = this.value.toLowerCase();
        this.classList.toggle('active', !!this.value);
        applyFilters();
      });
    }

    // Price sliders
    const sliderMin = document.getElementById('bse-price-min');
    const sliderMax = document.getElementById('bse-price-max');
    if (sliderMin && sliderMax) {
      sliderMin.addEventListener('input', function() {
        const val = parseInt(this.value);
        if (val >= state.priceMax) { this.value = state.priceMax - 50; return; }
        state.priceMin = val;
        document.getElementById('bse-price-min-val').textContent = val.toLocaleString('en-ZA');
        updateRangeFill();
        applyFilters();
      });
      sliderMax.addEventListener('input', function() {
        const val = parseInt(this.value);
        if (val <= state.priceMin) { this.value = state.priceMin + 50; return; }
        state.priceMax = val;
        document.getElementById('bse-price-max-val').textContent = val.toLocaleString('en-ZA');
        updateRangeFill();
        applyFilters();
      });
    }

    // Category tiles
    document.querySelectorAll('.bse-cat').forEach(btn => {
      btn.addEventListener('click', function() {
        document.querySelectorAll('.bse-cat').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        state.category = this.dataset.cat;
        applyFilters();
      });
    });

    // Clear all
    const clearAll = document.getElementById('bse-clear-all');
    if (clearAll) {
      clearAll.addEventListener('click', resetAll);
    }
  }

  function updateRangeFill() {
    const fill   = document.getElementById('bse-range-fill');
    const sMin   = document.getElementById('bse-price-min');
    const sMax   = document.getElementById('bse-price-max');
    if (!fill || !sMin || !sMax) return;
    const max    = parseInt(sMax.max) || 50000;
    const leftPc = (parseInt(sMin.value) / max) * 100;
    const rightPc= (parseInt(sMax.value) / max) * 100;
    fill.style.left  = leftPc + '%';
    fill.style.width = (rightPc - leftPc) + '%';
  }

  // ── FILTER ENGINE ──────────────────────────────────
  function applyFilters() {
    let visible = 0;

    cards.forEach(card => {
      const type      = (card.dataset.type    || '').toLowerCase();
      const vendor    = (card.dataset.vendor  || '').toLowerCase();
      const title     = (card.dataset.title   || '').toLowerCase();
      const tags      = (card.dataset.tags    || '').toLowerCase();
      const available = card.dataset.available === 'true';
      const priceCents= parseInt(card.dataset.price || 0);
      const priceRand = priceCents / 100;

      let show = true;

      // Keyword
      if (state.keyword) {
        const kw = state.keyword;
        if (!title.includes(kw) && !vendor.includes(kw) && !type.includes(kw) && !tags.includes(kw)) {
          show = false;
        }
      }

      // Category
      if (show && state.category !== 'all') {
        const keywords = catMap[state.category] || [];
        const combined = type + ' ' + tags;
        const matched  = keywords.some(kw => combined.includes(kw));
        if (!matched) show = false;
      }

      // Brand
      if (show && state.brand) {
        if (!vendor.includes(state.brand)) show = false;
      }

      // In Stock
      if (show && state.inStock) {
        if (!available) show = false;
      }

      // Price
      if (show) {
        if (priceRand < state.priceMin || priceRand > state.priceMax) show = false;
      }

      card.classList.toggle('bse-hidden', !show);
      if (show) visible++;
    });

    // No results state
    if (noResults) noResults.style.display = visible === 0 ? 'block' : 'none';
    if (grid)       grid.style.display      = visible === 0 ? 'none' : '';
    if (showingCount) showingCount.textContent = visible;

    // Status bar
    renderStatus(visible);
  }

  // ── STATUS BAR ─────────────────────────────────────
  function renderStatus(visible) {
    const hasFilters = state.keyword || state.category !== 'all' || state.brand || state.inStock || state.priceMin > 0 || state.priceMax < (parseInt(document.getElementById('bse-price-max')?.max || 50000));
    const clearAllBtn = document.getElementById('bse-clear-all');

    if (clearAllBtn) clearAllBtn.classList.toggle('visible', hasFilters);
    if (statusBar)   statusBar.style.display = hasFilters ? 'flex' : 'none';
    if (!hasFilters) return;

    if (resultCount) resultCount.textContent = `${visible} result${visible !== 1 ? 's' : ''} found`;

    const tags = [];
    if (state.keyword)     tags.push({ label: `"${state.keyword}"`,   key: 'keyword' });
    if (state.category !== 'all') {
      const btn = document.querySelector(`.bse-cat[data-cat="${state.category}"]`);
      tags.push({ label: btn ? btn.querySelector('.bse-cat-label').textContent : state.category, key: 'category' });
    }
    if (state.brand)       tags.push({ label: state.brand,             key: 'brand' });
    if (state.inStock)     tags.push({ label: 'In Stock only',         key: 'inStock' });
    if (state.priceMin > 0) tags.push({ label: `R${state.priceMin.toLocaleString('en-ZA')}+`, key: 'priceMin' });

    if (activeTags) {
      activeTags.innerHTML = tags.map(t =>
        `<span class="bse-active-tag">${t.label}<button class="bse-tag-remove" data-key="${t.key}" title="Remove filter">✕</button></span>`
      ).join('');

      activeTags.querySelectorAll('.bse-tag-remove').forEach(btn => {
        btn.addEventListener('click', function() {
          removeFilter(this.dataset.key);
        });
      });
    }
  }

  function removeFilter(key) {
    if (key === 'keyword') {
      state.keyword = '';
      const kwInput = document.getElementById('bse-keyword');
      const kwClear = document.getElementById('bse-search-clear');
      if (kwInput) kwInput.value = '';
      if (kwClear) kwClear.classList.remove('visible');
    } else if (key === 'category') {
      state.category = 'all';
      document.querySelectorAll('.bse-cat').forEach(b => b.classList.remove('active'));
      document.querySelector('.bse-cat[data-cat="all"]')?.classList.add('active');
    } else if (key === 'brand') {
      state.brand = '';
      const brandSel = document.getElementById('bse-brand');
      if (brandSel) { brandSel.value = ''; brandSel.classList.remove('active'); }
    } else if (key === 'inStock') {
      state.inStock = false;
      const toggle = document.getElementById('bse-instock');
      if (toggle) toggle.checked = false;
    } else if (key === 'priceMin') {
      state.priceMin = 0;
      const sMin = document.getElementById('bse-price-min');
      if (sMin) { sMin.value = 0; }
      document.getElementById('bse-price-min-val').textContent = '0';
      updateRangeFill();
    }
    applyFilters();
  }

  function resetAll() {
    state.keyword  = '';
    state.category = 'all';
    state.brand    = '';
    state.inStock  = false;
    state.priceMin = 0;

    const kwInput  = document.getElementById('bse-keyword');
    const kwClear  = document.getElementById('bse-search-clear');
    const brandSel = document.getElementById('bse-brand');
    const toggle   = document.getElementById('bse-instock');
    const sMin     = document.getElementById('bse-price-min');
    const sMax     = document.getElementById('bse-price-max');

    if (kwInput)  kwInput.value  = '';
    if (kwClear)  kwClear.classList.remove('visible');
    if (brandSel) { brandSel.value = ''; brandSel.classList.remove('active'); }
    if (toggle)   toggle.checked  = false;
    if (sMin)     sMin.value      = 0;
    if (sMax)     { state.priceMax = parseInt(sMax.max); sMax.value = sMax.max; }

    document.getElementById('bse-price-min-val').textContent = '0';
    document.getElementById('bse-price-max-val').textContent = (parseInt(sMax?.max||50000)).toLocaleString('en-ZA');
    updateRangeFill();

    document.querySelectorAll('.bse-cat').forEach(b => b.classList.remove('active'));
    document.querySelector('.bse-cat[data-cat="all"]')?.classList.add('active');

    applyFilters();
  }

  // ── BOOT ───────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

/* ═══════════════════════════════════════════════════
   HERO SLIDER ENGINE — v2.6.0
   ═══════════════════════════════════════════════════ */

const bseSlider = (function() {
  let current = 0;
  let total = 0;
  let autoplayTimer = null;
  let progressTimer = null;
  let progressStart = null;
  let slides, dots, progressBar;
  const SPEED = 6000; // 6 seconds per slide

  function init() {
    slides = document.querySelectorAll('#heroSlider .slide');
    dots = document.querySelectorAll('.slider-dot');
    progressBar = document.getElementById('sliderProgressBar');
    if (!slides.length) return;
    total = slides.length;
    startAutoplay();

    // Pause on hover
    const slider = document.getElementById('heroSlider');
    if (slider) {
      slider.addEventListener('mouseenter', pauseAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
      // Touch support
      let touchStartX = 0;
      slider.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
      slider.addEventListener('touchend', e => {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) diff > 0 ? next() : prev();
      }, { passive: true });
    }
  }

  function goTo(index) {
    if (index === current) return;
    // Exit current
    slides[current].classList.add('exit');
    slides[current].classList.remove('active');
    dots[current]?.classList.remove('active');
    setTimeout(() => slides[index - 1 >= 0 ? index : 0]?.classList.remove('exit'), 700);

    // Remove exit from old after transition
    const oldSlide = slides[current];
    setTimeout(() => oldSlide.classList.remove('exit'), 750);

    current = ((index % total) + total) % total;

    slides[current].classList.add('active');
    dots[current]?.classList.add('active');

    resetProgress();
  }

  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  function startAutoplay() {
    pauseAutoplay();
    resetProgress();
    autoplayTimer = setInterval(() => next(), SPEED);
  }

  function pauseAutoplay() {
    clearInterval(autoplayTimer);
    clearInterval(progressTimer);
    if (progressBar) progressBar.style.transition = 'none';
  }

  function resetProgress() {
    if (!progressBar) return;
    progressBar.style.transition = 'none';
    progressBar.style.width = '0%';
    setTimeout(() => {
      progressBar.style.transition = `width ${SPEED}ms linear`;
      progressBar.style.width = '100%';
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return { goTo, next, prev };
})();
